export default {
	byKey: {
		displacement: {
			key: 'displacement',
			data: {
				nameDisplay: 'Displacement velocity',
				stylesByType: {
					los: {
						asMarkers: 'displacementLosAsMarkers',
						asPoints: 'displacementLosAsPoints',
						asPointsSmall: 'displacementLosAsPointsSmall',
					},
					dts: {
						asMarkers: 'displacementDtsAsMarkers',
						asPoints: 'displacementDtsAsPoints',
						asPointsSmall: 'displacementDtsAsPointsSmall',
					},
					vertg: {
						asMarkers: 'displacementLosAsMarkers',
						asPoints: 'displacementLosAsPoints',
						asPointsSmall: 'displacementLosAsPointsSmall',
					},
					vertggps: {
						asMarkers: 'displacementLosAsMarkers',
						asPoints: 'displacementLosAsPoints',
						asPointsSmall: 'displacementLosAsPointsSmall',
					},
				},
				orderingByType: {
					los: {
						attribute: 'vel_avg',
						order: 'asc',
						type: 'abs',
					},
					dts: {
						attribute: 'vel_avg',
						order: 'asc',
						type: 'abs',
					},
					vertg: {
						attribute: 'vel_avg',
						order: 'asc',
						type: 'abs',
					},
					vertggps: {
						attribute: 'vel_avg',
						order: 'asc',
						type: 'abs',
					},
				},
			},
		},
		trendDynamics: {
			key: 'trendDynamics',
			data: {
				nameDisplay: 'Trend dynamics',
				stylesByType: {
					los: {
						asMarkers: 'trendDynamicsLosAsMarkers',
						asPoints: 'trendDynamicsLosAsPoints',
						asPointsSmall: 'trendDynamicsLosAsPointsSmall',
					},
					dts: {
						asMarkers: 'trendDynamicsDtsAsMarkers',
						asPoints: 'trendDynamicsDtsAsPoints',
						asPointsSmall: 'trendDynamicsDtsAsPointsSmall',
					},
					vertg: {
						asMarkers: 'trendDynamicsLosAsMarkers',
						asPoints: 'trendDynamicsLosAsPoints',
						asPointsSmall: 'trendDynamicsLosAsPointsSmall',
					},
					vertggps: {
						asMarkers: 'trendDynamicsLosAsMarkers',
						asPoints: 'trendDynamicsLosAsPoints',
						asPointsSmall: 'trendDynamicsLosAsPointsSmall',
					},
				},
				orderingByType: {
					los: {
						attribute: 'cl_dyn',
						order: 'asc',
						type: 'trendDynamics',
					},
					dts: {
						attribute: 'cl_dyn',
						order: 'asc',
						type: 'trendDynamics',
					},
					vertg: {
						attribute: 'cl_dyn',
						order: 'asc',
						type: 'trendDynamics',
					},
					vertggps: {
						attribute: 'cl_dyn',
						order: 'asc',
						type: 'trendDynamics',
					},
				},
			},
		},
		trendCluster: {
			key: 'trendCluster',
			data: {
				nameDisplay: 'Trend cluster',
				stylesByType: {
					vertggps: {
						asMarkers: 'trendClusterVertggpsAsMarkers',
						asPoints: 'trendClusterVertggpsAsPoints',
						asPointsSmall: 'trendClusterVertggpsAsPointsSmall',
					},
				},
				orderingByType: {
					vertggps: {
						attribute: 'cl_clstr',
						order: 'asc',
						type: 'trendCluster',
					},
				},
			},
		},
	},
};
